import React, { useState, useEffect } from 'react';
import { $UsageCreate, $UsageUpdate, UsagesVService } from '../../services/V2/gozer';
import { useParams } from 'react-router';
import { AddModal } from '../shared/AddModal';
import { EditModal } from '../shared/EditModal';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import { authProvider } from '../../services/Security';
import { CustomTable } from '../shared/CustomTable';

export const MeterUsages = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [showAdd, setShowAdd] = useState<boolean>(false);
    const [showEdit, setShowEdit] = useState<boolean>(false);
    const [token, setToken] = useState<any>();
    const [rowData, setRowData] = useState<any>();
    const [canUpdateUsage, setCanUpdateUsage] = useState<boolean>(false);
    const [canCreateUsage, setCanCreateUsage] = useState<boolean>(false);
    const [canDeleteUsage, setCanDeleteUsage] = useState<boolean>(false);
    const { serviceAddressId, meterId } = useParams<{ serviceAddressId: string, meterId: string }>();

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if (!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setToken(data?.token)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        if (!token) return;

        let perms = authProvider.getPermissions();
        setCanUpdateUsage(perms.some((perm: string) => perm === "UpdateUsages"));
        setCanCreateUsage(perms.some((perm: string) => perm === "CreateUsages"));
        setCanDeleteUsage(perms.some((perm: string) => perm === "DeleteUsages"));
    }, [token])// eslint-disable-line react-hooks/exhaustive-deps

    const handleShowEdit = (row) => {
        setRowData(row)
        setShowEdit(true);
    }

    return (
        <React.Fragment>
            {showAdd &&
                <AddModal
                    setShow={setShowAdd}
                    show={showAdd}
                    setLoading={setLoading}
                    loading={loading}
                    addEndpoint={UsagesVService.usagesVCreate}
                    keys={$UsageCreate.properties}
                    modelName="Meter Usage"
                    parentId={meterId}
                    parentsParentId={serviceAddressId}
                    parent={null}
                    parentValues={[]}
                    canReadUserRoles={false}
                    successMessage={null}
                    successCallback={null}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            {showEdit &&
                <EditModal
                    modelId={rowData.id}
                    parentId={meterId}
                    parentsParentId={serviceAddressId}
                    data={rowData}
                    modelName="Meter Usage"
                    setShow={setShowEdit}
                    setLoading={setLoading}
                    loading={loading}
                    isEdit={true}
                    editEndpoint={UsagesVService.usagesVUpdateUsage}
                    extraEndpoint={null}
                    deleteEndpoint={UsagesVService.usagesVDelete}
                    viewKeys={null}
                    editKeys={$UsageUpdate.properties}
                    extraKeys={null}
                    hardDelete={canDeleteUsage}
                    canReadUserRoles={false}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            <CustomTable
                title="Meter Usages"
                columns={[
                    { title: 'Meter Usage Id', field: 'id', editable: 'never' },
                    { title: 'Meter Id', field: 'meterId', editable: 'never' },
                    { title: 'Amount', field: 'amount', editable: 'never' },
                    { title: 'Read Date', editable: 'never', render: (rowData: any) => rowData.readDate.toLocaleString() },
                ]}
                dataEndpoint={query => {
                    return new Promise((resolve, reject) => {
                        UsagesVService.usagesVGetAll(serviceAddressId, meterId, {
                            pageNumber: query.page + 1,
                            numberPerPage: query.pageSize,
                            orderBy: query?.orderBy?.field?.toString() ?? "Id",
                            orderByDesc: query.orderDirection === "desc",
                            filters: [],
                            searchQuery: query.search
                        }).then((x: any) => {
                            resolve({
                                data: x.items ?? [],
                                page: query.page,
                                totalCount: x.numberOfItems ?? 0
                            })
                        }).catch(x => {
                            reject(x)
                        })
                    })
                }}
                actions={[
                    {
                        icon: 'refresh',
                        tooltip: 'Refresh Data',
                        isFreeAction: true,
                        onClick: () => { setLoading(!loading) },
                    },
                    {
                        icon: () => <AddIcon />,
                        tooltip: 'Add Usage',
                        isFreeAction: true,
                        onClick: () => setShowAdd(true),
                        disabled: !canCreateUsage
                    },
                    {
                        icon: () => <EditIcon />,
                        tooltip: 'Edit Usage',
                        onClick: (event, row) => handleShowEdit(row),
                        disabled: !canUpdateUsage
                    }
                ]}
                refresh={loading} setRefresh={setLoading} pageSize={15} enablePaging={true}
                districtId={null} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { }} hiddenColumnsDisabled={true}
                tableHeight={"400px"} enableSearch={false} searchPlaceholder={null} dataSet={null}
            />
        </React.Fragment>
    );
}